import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * useContent — fetches published content for a given kind from the API.
 * If the fetch fails or returns empty, falls back to the provided static data.
 */
export const useContent = (kind, fallback = []) => {
  const [items, setItems] = useState(fallback);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      setLoading(true);
      try {
        const { data } = await api.get(`/content/${kind}`);
        if (!cancelled) {
          setItems(Array.isArray(data) && data.length > 0 ? data : fallback);
        }
      } catch (e) {
        if (!cancelled) {
          setError(e);
          setItems(fallback);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kind]);

  return { items, loading, error };
};
